import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneBanner, updateBanner } from 'slice/bannerSlice'; // Import your action creator to fetch a single product
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateBanner = () => {
    const { id } = useParams(); // Get the id parameter from the URL
    const dispatch = useDispatch();
    const nevigate = useNavigate();
    const { loading, data } = useSelector((state) => state.banner);
    const [formData, setFormData] = useState({
        name: '',
        selling_price: '',
        shipping_charge: '1000',
        original_price: '',
        rating: '0',
        stock_quantity: '',
        description: '',
        processor: '',
        ram: '',
        storage: '',
        battery_life: '',
        weight: '',
        screen_size: '',
        gpu: '',
        product_id: '',
        stock: '',
        is_active: '1',
        image: null,
    });

    useEffect(() => {
        dispatch(getOneBanner(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (Object.keys(data).length > 0) {
            const normalizedActive = data.is_active === 0 || data.is_active === '0' ? '0' : '1';
            setFormData({
                name: data.name || '',
                selling_price: data.selling_price ?? '',
                shipping_charge: data.shipping_charge ?? '1000',
                original_price: data.original_price ?? '',
                rating: data.rating ?? '0',
                stock_quantity: data.stock_quantity ?? '',
                description: data.description || '',
                processor: data.processor || '',
                ram: data.ram || '',
                storage: data.storage || '',
                battery_life: data.battery_life || '',
                weight: data.weight || '',
                screen_size: data.screen_size || '',
                gpu: data.gpu || '',
                product_id: data.product_id || '',
                stock: data.stock ?? '',
                is_active: normalizedActive,
                image: null,
            });
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formDataToSend = new FormData();
            for (const key in formData) {
                if (key === 'image' && !formData[key]) continue;
                formDataToSend.append(key, formData[key]);
            }

            dispatch(updateBanner({id: id, data: formDataToSend}))
            toast('Banner updated successfully!');
            nevigate('/banner')

        } catch (error) {
            console.error('There was a problem updating the product:', error.message);
        }
    };


    return (
        <>
            <div className='container card my-5'>
                <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='productName'>Banner Name</label>
                        <input type='text' id='productName' name='name' value={formData.name} className='form-control' onChange={handleChange} required />
                    </div>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='bannerSellingPrice'>Selling Price</label>
                        <input id='bannerSellingPrice' type='number' name='selling_price' value={formData.selling_price} className='form-control' onChange={handleChange} required />
                    </div>
                    <div className='col-sm-6 mt-3'>
                        <label htmlFor='bannerShipping'>Shipping Charge</label>
                        <input id='bannerShipping' type='number' name='shipping_charge' value={formData.shipping_charge} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-6 mt-3'>
                        <label htmlFor='bannerOriginalPrice'>Original Price</label>
                        <input id='bannerOriginalPrice' type='number' name='original_price' value={formData.original_price} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-6 mt-3'>
                        <label htmlFor='bannerRating'>Rating</label>
                        <input id='bannerRating' type='number' step='0.1' name='rating' value={formData.rating} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-6 mt-3'>
                        <label htmlFor='bannerStockQty'>Stock Quantity</label>
                        <input id='bannerStockQty' type='number' name='stock_quantity' value={formData.stock_quantity} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-6 mt-2'>
                        <label htmlFor='bannerStatus'>Status</label>
                        <select id='bannerStatus' name='is_active' value={formData.is_active} className='form-control' onChange={handleChange}>
                            <option value='1'>Active</option>
                            <option value='0'>Inactive</option>
                        </select>
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerDescription'>Description</label>
                        <textarea id='bannerDescription' name='description' value={formData.description} className='form-control' rows='3' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerProcessor'>Processor</label>
                        <input id='bannerProcessor' type='text' name='processor' value={formData.processor} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerRam'>RAM</label>
                        <input id='bannerRam' type='text' name='ram' value={formData.ram} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerStorage'>Storage</label>
                        <input id='bannerStorage' type='text' name='storage' value={formData.storage} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerBattery'>Battery Life</label>
                        <input id='bannerBattery' type='text' name='battery_life' value={formData.battery_life} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerWeight'>Weight</label>
                        <input id='bannerWeight' type='text' name='weight' value={formData.weight} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerScreen'>Screen Size</label>
                        <input id='bannerScreen' type='text' name='screen_size' value={formData.screen_size} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerGpu'>GPU</label>
                        <input id='bannerGpu' type='text' name='gpu' value={formData.gpu} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerProduct'>Product ID</label>
                        <input id='bannerProduct' type='number' name='product_id' value={formData.product_id} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerStock'>Stock</label>
                        <input id='bannerStock' type='number' name='stock' value={formData.stock} className='form-control' onChange={handleChange} />
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <label htmlFor='bannerImage'>Banner Image</label>
                        <input type='file' id='bannerImage' name='image' className='form-control btn-block filebg' onChange={handleChange} />
                        {data?.image ? (
                            <small className='form-text text-muted'>Current: {data.image}</small>
                        ) : null}
                    </div>
                </div>
                <div className='mt-3 text-right'>
                    <button className='btn btn-success' disabled={loading}>Update Banner</button>
                </div>
                </form>
            </div>
        </>
    )
}

export default UpdateBanner;
